export default "__VITE_ASSET__Cg7vEGIl__"